import { render, staticRenderFns } from "./ImportCampaignModal.vue?vue&type=template&id=5484b022&scoped=true"
import script from "./ImportCampaignModal.vue?vue&type=script&lang=js"
export * from "./ImportCampaignModal.vue?vue&type=script&lang=js"
import style0 from "./ImportCampaignModal.vue?vue&type=style&index=0&id=5484b022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5484b022",
  null
  
)

export default component.exports